import { t } from 'i18next'
import LocalStorage from 'services/LocalStorage'
import { LocalStorageKey } from 'types/services/localStorage'
import { isGroupcalApp } from './appType'
import { SUPPORT_EMAIL, SUPPORT_EMAIL_TFM } from './strings'
import UAParser from 'ua-parser-js'
import i18n from 'i18n'

export function isTestEnv() {
  return (
    process.env.REACT_APP_ENV === 'TESTING' ||
    process.env.REACT_APP_ENV === 'STAGING'
  )
}

export function isInIframe(): boolean {
  return window.self !== window.top
}

export function browserDetails(): string {
  const deviceData = UAParser(window.navigator.userAgent)

  return (
    '%0D%0A' +
    `Browser: ${deviceData.browser.name}; ver: ${deviceData.browser.version}` +
    '%0D%0A' +
    `Language: ${i18n.language}` +
    '%0D%0A' +
    `Phone: ${LocalStorage.get(LocalStorageKey.PHONE_NUMBER)}` +
    '%0D%0A' +
    `Version: ${process.env.APP_VERSION}`
  )
}

export function sendEmailToUs() {
  const subject = t(isGroupcalApp() ? 'emailSubject' : 'emailSubjectTfm')

  window.open(
    `mailto:${
      isGroupcalApp() ? SUPPORT_EMAIL : SUPPORT_EMAIL_TFM
    }?subject=${subject}&body=${` %0D%0A%0D%0A%0D%0A%0D%0A Technical info for this report: ${browserDetails()}`}`
  )
}
